module.exports = __webpack_public_path__ + "static/media/8.34a6bef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/8.png
// module id = 1247
// module chunks = 0